<template>
	<AppModal @hide-modal="$emit('cancel')">
		<template #header>Wil je de offerteaanvraag aanpassen?</template>

		<AppModalContent>
			<p>Weet je zeker dat je de offerteaanvraag wilt aanpassen?</p>
			<p v-if="error" style="color: var(--color-fail)">
				{{ error.message }}
			</p>
		</AppModalContent>

		<template #footer>
			<AppButtonGroup>
				<AppButton
					variant="primary"
					:loading="loading"
					@click="$emit('submit')"
				>
					Aanvraag aanpassen
				</AppButton>
				<AppButton variant="secondary" @click="$emit('cancel')">
					Annuleren
				</AppButton>
			</AppButtonGroup>
		</template>
	</AppModal>
</template>

<script lang="ts" setup>
import type { ApiError } from "@/models/ApiError";

interface Props {
	loading: boolean;
	error: ApiError | null;
}
defineProps<Props>();

defineEmits<{
	submit: [payload: void];
	cancel: [payload: void];
}>();
</script>
